// extracted by mini-css-extract-plugin
export default {"body":"discount_body__ZQ7Q-","needLoadingGoods":"discount_needLoadingGoods__ROWIX","goodsWrapper":"discount_goodsWrapper__ybxo+"};